import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { settingsActions } from './action'
import MainForm from './components/MainForm'
import SideBar from './components/SideBar'
import UpdateForm from './components/UpdateForm'
import GroupForm from './components/GroupForm'
import VerificationForm from './components/VerificationForm'
import NotificationsForm from './components/NotificationsForm'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import CloseAccForOrgManagerModal from './components/CloseAccForOrgManagerModal'
import DocumentList from 'srcReact/OrganizationSettingsPage/components/OrgDocuments/DocumentList'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import IntegrationSettings from 'srcReact/Pages/IntegrationSettings'
import MobileModal from 'srcReact/components/common2/MobileModal'

const Settings = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [isCloseAccountModalOpen, setIsCloseAccountModalOpen] = useState(false)
  const [closeAccType, setCloseAccType] = useState('')
  useEffect(() => {
    dispatch(settingsActions.getUserDetails())
  }, [])

  const {
    formActive,
    verificationFormActive,
    organizationDocsActive,
    integrationActive,
    notificationsformActive,
    groupFormActive
  } = useSelector((state) => state.settings)
  const { isNative, isMobile } = useSelector((state) => state.common)

  const openCloseAccountModal = (type) => {
    setIsCloseAccountModalOpen(true)
    setCloseAccType(type)
  }
  const hideCloseAccountModal = () => {
    setIsCloseAccountModalOpen(false)
  }
  const handleClose = () => {
    dispatch(settingsActions.setUpdateFormActive(false))
  }

  return (
    <PageContainer
      pageClassName={`${styles.pageContainer} ${isNative && styles.isNative}`}
      withHeader={true}
      withFooter={false}>
      <SideBar openCloseAccountModal={openCloseAccountModal} />
      {!notificationsformActive && !organizationDocsActive && !integrationActive && (
        <MainForm openCloseAccountModal={openCloseAccountModal} />
      )}
      {notificationsformActive && <NotificationsForm />}
      {/* {formActive && !verificationFormActive && <UpdateForm />} */}
      {formActive && !verificationFormActive ? (
        isMobile ? (
          <MobileModal
            isOpen={formActive && !verificationFormActive}
            lockScroll={false}
            showBackArrow={false}
            showDraggableDiv={false}
            showDefaultHeader={false}
            handleClose={handleClose}
            customContentStyle={{
              height: isNative ? '95vh' : 'calc(100vh - 95px)',
              justifyContent: 'flex-start'
            }}>
            <UpdateForm />
          </MobileModal>
        ) : (
          <UpdateForm />
        )
      ) : null}
      {verificationFormActive && <VerificationForm />}
      {organizationDocsActive && (
        <div className={`${styles.mainWrapper} ${styles.docListWrapper}`}>
          <h1 className={styles.title}>{t('account_settings.sidebar.orgDocuments')}</h1>
          <DocumentList orgId={getCurrentOrgId()} />
        </div>
      )}
      {integrationActive && (
        <div className={`${styles.mainWrapper}`}>
          <h1 className={styles.title}>{t('integration.title')}</h1>
          <h2 className={styles.subTitle}>{t('integration.subTitle')}</h2>
          <IntegrationSettings from='user_settings' />
        </div>
      )}
      {groupFormActive && <GroupForm />}
      {isCloseAccountModalOpen && (
        <CloseAccForOrgManagerModal
          showModal={isCloseAccountModalOpen}
          hideModal={hideCloseAccountModal}
          closeAccType={closeAccType}
          isNative={isNative}
        />
      )}
    </PageContainer>
  )
}

export default Settings
